import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { Subject } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { UploadModalComponent } from '../../upload-modal/upload-modal.component';
import {
  KnowledgeBaseContentFiles,
  KnowledgeBaseModalActionType,
  KnowledgeBasePayloadResponse
} from 'src/app/model';

@Injectable()
export class ManageModalService {

  modalResponse = new Subject<KnowledgeBaseModalActionType>();

  constructor(
    private modalService: NgbModal,
    private dialog: MatDialog,
    private service: ServicecallService,
    private router: Router
  ) { }

  setAction (type: KnowledgeBaseModalActionType, id?: string, blobUrls?: KnowledgeBaseContentFiles) {
    if (type === Messages.VIEW) {
      this.router.navigate(['wiki/view/', id]);
    } else if (type === Messages.EDIT) {
      this.showModal(type, id);
    } else if (type === Messages.DELETE && id) {      
      this.deleteModal(id, blobUrls);
    } else {
      this.showModal(type);
    }
  }

  showModal(type: KnowledgeBaseModalActionType, id?: string) {
    const modalRef = this.modalService.open(
      UploadModalComponent,
      {
        backdrop: "static",
        keyboard: false,
        windowClass: "PeopleModalClass"
      }
    );
    if (type === Messages.EDIT && id) {
      modalRef.componentInstance.formId = id;
    }
    modalRef.result.then(
      (result) => {
        if (result) {
          this.modalResponse.next(id ? 'edit' : 'add');
        }
      }, 
      (reason) => {}
    );
  }

  deleteModal(id: string, blobUrls?: KnowledgeBaseContentFiles) {
    const dialogRef = this.dialog.open(
      AlertDialogComponent, 
      {
        data: { msg: Messages.DELETE_KNOWLEDGE_BASE, type: null },
        disableClose: true
      }
    );
    dialogRef.afterClosed().subscribe(
      (dialogResponse: boolean) => {
        if (dialogResponse) {          
          this.service.deleteKnowledgeBase(
            {
              knowledgeBaseId: id
            }
          ).subscribe(
            (deleteResponse: KnowledgeBasePayloadResponse) => {
              if (deleteResponse.status) {
                if (deleteResponse.response) {
                  this.service.toasterService({ type: 'success', msg: deleteResponse?.response?.message });
                  if (blobUrls?.file) {                    
                    this.service.blobDelete(blobUrls?.file).subscribe(
                      (blobDeleteResponse: HttpResponse<any>) => {                        
                        if (blobDeleteResponse.status !== 202) {
                          this.service.toasterService({ type: 'error', msg: Messages.DELETE_FILE_FAILED });
                        }
                      }
                    );
                  }
                  if (blobUrls?.thumbnail) {                    
                    this.service.blobDelete(blobUrls?.thumbnail).subscribe(
                      (blobDeleteResponse: HttpResponse<any>) => {                        
                        if (blobDeleteResponse.status !== 202) {
                          this.service.toasterService({ type: 'error', msg: Messages.DELETE_FILE_FAILED });
                        }
                      }
                    );
                  }
                  this.modalResponse.next('delete');
                } else {
                  this.service.toasterService({ type: 'error', msg: deleteResponse?.response?.message });
                }
              }
            }
          );
        }
      }
    );
  }
}
